// extracted by mini-css-extract-plugin
export var active = "_j1-2";
export var recordingDot = "_j1-1";
export var recordingIndicator = "_j1-0";